export const formatUrlForDisplay = (inputUrl: string): string => {
  return !/^https?:\/\//i.test(inputUrl) ? 'https://' + inputUrl : inputUrl;
};
